import styles from './style.postcss';
import React, { PureComponent } from 'react';
import is from 'is_js';
import Header from './Header';
import Body from './Body';
import Row from './Row';
import Cell from './Cell';
import classnames from 'classnames';
import { testClass } from 'omni-common-ui';
import PropTypes from 'prop-types';

class SimpleTable extends PureComponent {
  constructor(props) {
    super(props);
    this._setUpData(props);
  }

  componentWillUpdate(props) {
    this._setUpData(props);
  }

  _setUpData(props) {
    const children = React.Children.toArray(props.children);
    this._header = children.find((child) => child.type === Header);
    this._buildCell = children.find((child) => child.type === Body).props.children;
    this._columnIds = getColumnIds(this._header);
  }

  _isColumnHighlighted(columnIndex, colSpan = 1) {
    if (is.not.array(this.props.highlightedColumns)) {
      return false;
    }

    const calculatedIndex = columnIndex * colSpan;
    return this.props.highlightedColumns.indexOf(calculatedIndex) >= 0;
  }

  _isRowStriped(rowIndex) {
    if (is.not.array(this.props.stripeRows)) {
      return false;
    }

    return this.props.stripeRows.indexOf(rowIndex) >= 0;
  }

  _wrapCellContentIfNeeded(cellContent, columnIndex) {
    if (cellContent.type === Cell) {
      return <Cell {...cellContent.props}
          highlighted={this._isColumnHighlighted(columnIndex)}
          onlyRowDivider={this.props.onlyRowDivider}
          key={columnIndex}>
        {cellContent.props.children}
      </Cell>;
    }

    return <Cell highlighted={this._isColumnHighlighted(columnIndex)}
        onlyRowDivider={this.props.onlyRowDivider}
        key={columnIndex}>
      {cellContent}
    </Cell>;
  }

  _renderHeader() {
    return <Header>
      {
        React.Children.map(this._header.props.children, (row) => <Row>
          {
            React.Children.map(row.props.children, (cell, columnIndex) => {
              if (! cell) return null;
              return <Cell {...cell.props}
                  highlighted={this._isColumnHighlighted(columnIndex, cell.props.colSpan)}
                  onlyRowDivider={this.props.onlyRowDivider}>
                {cell.props.children}
              </Cell>;
            })
          }
        </Row>)
      }
    </Header>;
  }

  render() {
    const classes = classnames(styles.SimpleTable, testClass('simple-table'), {
      [styles.__flex]: this.props.flex,
      [styles.__alignLeft]: this.props.textAlign === 'left',
      [styles.__alignCenter]: this.props.textAlign !== 'left',
      [styles.__heightFillParent]: this.props.isFullHeightToPanel,
    });
    return <table className={classes} ref={this.props.tableRef}>
      {this._renderHeader()}
      <tbody className={styles.SimpleTable_body}>
        {
          this.props.rows.map((row, rowIndex) => <Row stripe={this._isRowStriped(rowIndex)}
              className={testClass(`table-row-${rowIndex + 1}`)}
              // eslint-disable-next-line react/no-array-index-key
              key={rowIndex}>
            {
              this._columnIds.map((columnId, columnIndex) => {
                const cell = this._buildCell(row, columnId);
                if (cell === null) {
                  return null;
                }

                if (is.array(cell)) {
                  return cell.map((cellIt) =>
                      this._wrapCellContentIfNeeded(cellIt, columnIndex, rowIndex));
                }

                return this._wrapCellContentIfNeeded(cell, columnIndex, rowIndex);
              })
            }
          </Row>)
        }
      </tbody>
    </table>;
  }
}

SimpleTable.propTypes = {
  rows: PropTypes.oneOfType([PropTypes.shape(), PropTypes.arrayOf(PropTypes.any)]),
  children: PropTypes.node,
  stripeRows: PropTypes.arrayOf(PropTypes.number),
  highlightedColumns: PropTypes.arrayOf(PropTypes.number),
  tableRef: PropTypes.func,
  onlyRowDivider: PropTypes.bool,
  flex: PropTypes.bool,
  textAlign: PropTypes.oneOf(['left', 'center']),
  isFullHeightToPanel: PropTypes.bool,
};

export default SimpleTable;

function getColumnIds(header) {
  return recursive(header);
  function recursive(header, columns = []) { // eslint-disable-line no-shadow
    React.Children.toArray(header.props.children).forEach((child) => {
      if (child.type === Row) {
        return recursive(child, columns);
      }

      if (child.type !== Cell ||
          is.undefined(child.props.columnId)) {
        return;
      }

      columns.push(child.props.columnId);
    });

    return columns;
  }
}



// WEBPACK FOOTER //
// ./components/SimpleTable/component.jsx